import nopInstance from "../nopInstance.js";

const search = async (query) => {
  if (query) {
    const response = await nopInstance.get(`api/search?${query}`);
    return response;
  }
}

export default {
    search,
}